import LineChart, {getAggregateValue} from './LineChart'

export {LineChart, getAggregateValue}

export default LineChart
